/** Locale-aware calendar date (e.g. `21. 8.` / `21/08` / `8/21`). */
export const getLocaleDate = (value: Date | number | string, locale: string): string =>
    new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'numeric' }).format(new Date(value));

/** Locale-aware clock time (12h or 24h per locale). */
export const getLocaleTime = (value: Date | number | string, locale: string): string =>
    new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit' }).format(new Date(value));

/** Locale-aware date + time. */
export const getLocaleDateTime = (value: Date | number | string, locale: string): string =>
    new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    }).format(new Date(value));
